import type { AppLocale } from "./index"
import { EXTENDED_EXTRA_SIGNAL_TITLES, EXTENDED_SIGNAL_TITLES } from "./extendedLocaleUi"
import { isExtendedLocale } from "./isExtendedLocale"
import { localizeSignalTitle as legacyLocalizeSignalTitle } from "./legacy/signalTitles"
import type { AppLocale as LegacyAppLocale } from "./legacy/index"
import {
  isPublicExtraLocale,
  PUBLIC_EXTRA_SIGNAL_EXTRAS,
  PUBLIC_EXTRA_SIGNAL_TITLES,
} from "./publicExtraSignals"
import { uzbekLatinToCyrillic } from "./uzbekCyrillic"
import { EXPANSION_SIGNAL_EXTRAS, EXPANSION_SIGNAL_TITLES, isExpansionLocale } from "./publicExpansionSignals"

const RU_TITLES = [
  "Срочно свяжитесь", "Мешаете проезду", "Мешаете разгрузке", "Машину эвакуируют", "Открыто окно",
  "Открыта дверь", "Открыт багажник", "Включены фары", "Сработала сигнализация", "Проблема с автомобилем",
  "Переставьте машину", "Мешаете спецтранспорту", "Спущено колесо", "Дети в машине", "Животное в машине",
  "Подрезал", "Резко тормозил", "Не уступил", "Не пропустил пешехода", "Ехал по обочине",
  "Проехал на красный", "Выехал на встречку", "Опасная скорость", "Опасное перестроение", "Не включил поворотник",
  "Не соблюдал дистанцию", "Парковка на тротуаре", "Парковка на месте для инвалидов", "Занял два места", "Перекрыл выезд",
  "Побибикать", "Подморгнуть", "Красивая машина", "Красивый номер", "Спасибо",
  "Вежливый водитель", "Аккуратный водитель", "Помог на дороге", "Пропустил", "Уступил",
  "Улыбнуться", "Приятная музыка", "Чистая машина", "Аккуратная парковка", "Снял на видео",
] as const

const INDEX_BY_RU_TITLE = new Map<string, number>(RU_TITLES.map((title, index) => [title, index]))

type ExtraSignalKey = "profanity" | "mud" | "sawRoad" | "goodLuck" | "countryman" | "meet"

const EXTRA_KEY_BY_RU_TITLE: Record<string, ExtraSignalKey> = {
  "Нецензурная брань #@!%&*": "profanity",
  "Облил грязью": "mud",
  "Виделись на дороге": "sawRoad",
  "Удачи на дороге": "goodLuck",
  "Земляк": "countryman",
  "Хочу познакомиться": "meet",
}

export function localizeSignalTitle(locale: AppLocale, title?: string | null): string {
  if (isExpansionLocale(locale)) {
    if (!title) return ""
    const canonicalRu = legacyLocalizeSignalTitle("ru", title)
    const extraKey = EXTRA_KEY_BY_RU_TITLE[canonicalRu]
    if (extraKey) return EXPANSION_SIGNAL_EXTRAS[locale][extraKey]
    const index = INDEX_BY_RU_TITLE.get(canonicalRu)
    if (index === undefined) return title
    return EXPANSION_SIGNAL_TITLES[locale][index] ?? title
  }
  if (isPublicExtraLocale(locale)) {
    if (!title) return ""
    const canonicalRu = legacyLocalizeSignalTitle("ru", title)
    const extraKey = EXTRA_KEY_BY_RU_TITLE[canonicalRu]
    if (extraKey) return PUBLIC_EXTRA_SIGNAL_EXTRAS[locale][extraKey]

    const index = INDEX_BY_RU_TITLE.get(canonicalRu)
    if (index === undefined) return title
    return PUBLIC_EXTRA_SIGNAL_TITLES[locale][index] ?? title
  }

  if (!isExtendedLocale(locale)) {
    const value = legacyLocalizeSignalTitle(locale as LegacyAppLocale, title)
    return locale === "uz" ? uzbekLatinToCyrillic(value) : value
  }
  if (!title) return ""

  const canonicalRu = legacyLocalizeSignalTitle("ru", title)
  const extraKey = EXTRA_KEY_BY_RU_TITLE[canonicalRu]
  if (extraKey) return EXTENDED_EXTRA_SIGNAL_TITLES[locale][extraKey]

  const index = INDEX_BY_RU_TITLE.get(canonicalRu)
  if (index === undefined) return title
  return EXTENDED_SIGNAL_TITLES[locale][index] ?? title
}
